export default __webpack_public_path__ + "static/hotel-lobby-362568_1280-ef20f8c7aec54c57b8a7f54b8482062e.png";